import Icon, { COLORS, ICONS } from '../../general-ui/icon';
import { Tooltip } from '../../general-ui/tooltip/tooltip';

interface Props {
    metricTitle: string;
    metricValue: number;
    info?: string;
}

export default function EventHeaderCard(props: Props): JSX.Element {
    const { metricTitle, metricValue, info } = props;

    function formatNumber(value: number) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    
    return (
        <div className="events-header-card">
            <div className="header-title">
                {metricTitle}
                <div className="header-info">
					{info ?
						<Tooltip tooltip={info}>
							<Icon name={ICONS.INFO_CIRCLE} size={10} color={COLORS.DEFAULT_GRAY} />
						</Tooltip>
						: <></>}
                </div>
            </div>
            <div className="header-content">
                <h3>{formatNumber(metricValue)}</h3>
                <div>{/* graph visualization*/}</div>
            </div>
        </div>
    );
}